import { Grid } from "@mui/material"
import Timer from "./Timer"
import { useCustomContext } from './ContextHook';
import stopWatch from '../images/stopwatch.png';


const BottomHeader = () => {
    const { configs } = useCustomContext()
    const currentEvent = configs?.currentEvent;
    const hasTimerText = currentEvent?.theme?.timer?.text !== undefined && currentEvent?.theme?.timer?.text.length > 0

    return currentEvent && currentEvent?.theme?.timer?.isEnabled
        ? (
            <Grid className="header-bottom">
                <Grid container flexDirection="row" justifyContent="center" alignContent="center" >
                    <Grid item>
                        <div className='promotion-text-container'>
                            <img src={stopWatch} alt="watch"/>
                            <p className="promotion-text">
                                {hasTimerText ? currentEvent?.theme?.timer?.text : 'Sale ends in'}
                                &nbsp;
                                <Timer
                                    startDate={currentEvent.startDate}
                                    endDate={currentEvent.endDate}
                                /></p>
                        </div>
                    </Grid>
                    <Grid item>
                        <Grid container flexDirection="row" justifyContent="center">
                            <Grid item className="timer-container">
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
        : null;
}
export default BottomHeader
